import utils from 'utils'
import fuzzySearch from './fuzzysearch'
class drawerinfo {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $location, $state, $stateParams, $uibModal) {
        $scope.dictData = {}

        httpRequest.get_dictByTypeArr('["certificate_type","identity_type","ovat_drawer_channel_type","qpt_login_type","yes_no_flag","drawer_business_scope"]').then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.title = '新增'
        let saveMsg = '新增成功',
            saveApi = 'post_ovatTax4Draweradd'
        $scope.formObj = {
            status: '1',
            invoiceType: '0',
            identityType: '9',
            businessScope: '0',
            certificateType: '101',
            mainOrgName: JSON.parse(localStorage.user_info).user.currentOrgName,
            orgIdList: [],
        }
        let path = $location.path()
        if (path.indexOf('edit') !== -1) {
            $scope.title = '编辑'
            saveMsg = '编辑成功'
            saveApi = 'post_ovatTax4Drawerupdate'
            httpRequest.post_ovatTax4Drawerget({ drawerId: $stateParams.drawerId }).then((res) => {
                res.data.value.identityType = '9'
                $scope.formObj = res.data.value
                $scope.formObj.editFlag = false
                $scope.formObj.qptServerUrl = $scope.formObj.qptServerUrl?$scope.formObj.qptServerUrl:''
                $scope.formObj.initialQptServerUrl = $scope.formObj.qptServerUrl
                if($scope.formObj.channelType=== '8'){
                    $scope.labelObjs[14].show = true
                }
                if($scope.formObj.loginType && $scope.formObj.loginType!== '0' && $scope.formObj.channelType!== '6') {
                    $scope.labelObjs[15].show = true
                    $scope.formObj.isDefault = $scope.formObj.isDefault?$scope.formObj.isDefault:'0'
                }
            })
            var orgSetting = {
                check: {
                    //如果没有设置配置项，取默认配置
                    enable: true, //显示不显示复选框
                    chkboxType: {
                        Y: 's',
                        N: 'ps',
                    },
                },
                data: {
                    simpleData: {
                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                        pIdKey: 'parentId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                    },
                    key: {
                        name: 'name',
                    },
                },
                view: {
                    showIcon: false, //是否显示节点的图标
                    showLine: false, //是否显示节点之间的连线
                },
                callback: {
                    onCheck: function (event, treeId, treeNode) {
                        var treeObj = $.fn.zTree.getZTreeObj('editOrgTree')
                        var editlistData = treeObj.getCheckedNodes()
                        if (editlistData) {
                            let orgIdList = []
                            angular.forEach(editlistData, (item, index) => {
                                if (item.checked) {
                                    orgIdList.push(item.id)
                                }
                                if (item.children) {
                                    item.children.forEach((ele) => {
                                        if (ele.checked) {
                                            orgIdList.push(ele.id)
                                        }
                                    })
                                }
                            })
                            $scope.formObj.orgIdList = orgIdList
                        }
                    },
                },
            }
            async function init() {
                // 获取当前开票员变更管理机构树
                await httpRequest.getEditDrawerOrgTree({ drawerId: $stateParams.drawerId }).then((res) => {
                    $scope.orgListData = res.data.value
                    $scope.formObj.orgIdList = []
                    angular.forEach($scope.orgListData, (item, index) => {
                        if (item.id == $scope.userInfo.org.orgId) {
                            item.checked = true
                        }
                        if (item.checked) {
                            $scope.formObj.orgIdList.push(item.id)
                        }
                        if (item.children) {
                            item.children.forEach((ele) => {
                                if (ele.checked) {
                                    $scope.formObj.orgIdList.push(ele.id)
                                }
                            })
                        }
                    })
                })
                $.fn.zTree.init($('#editOrgTree'), orgSetting, $scope.orgListData)
            }
            setTimeout(() => {
                init()
            }, 500)
        } else if (path.indexOf('detail') !== -1) {
            $scope.title = '详情'
            httpRequest.post_ovatTax4Drawerget({ drawerId: $stateParams.drawerId }).then((res) => {
                $scope.formObj = res.data.value
            })
        }

        const required = {
            // 验证为必填项
            erromsg: '必填项',
            condition(value) {
                return value === '' || /^[ ]+$/.test(value) || value === undefined || value === null
            },
        }
        const keepTwo = {
            erromsg: '最多保留两位小数',
            condition(value) {
                if (!value) return
                let reg = /^-?(0|([1-9][0-9]*))(\.[\d]{1,2})?$/
                return !reg.test(value)
            },
        }
        const keepLength = {
            erromsg: '必填项',
            condition(value) {
                return value && !value.length
            },
        }
        const maxLength50 = {
            erromsg: '最多支持50个字符',
            condition(value) {
                if (!value) return
                return value.length > 50
            },
        }
        let addLabel = [
            {
                label: '姓名',
                key: 'realName',
                required: true,
                show: true,
                rules: [required],
                tooltip: true,
                title: '请填写电子税局备案的实名姓名',
            },
            {
                label: '手机号',
                key: 'mobile',
                required: true,
                rules: [required],
                show: true,
                dictKey: '',
                tooltip: true,
                title: '请填写电子税局备案的手机号',
            },
            {
                label: '身份类型',
                key: 'identityType',
                type: 'select',
                required: true,
                rules: [required],
                show: true,
                disabled: true,
                dictKey: 'identity_type',
                tooltip: true,
                title: '请确保电子税局登录账号的身份类型为开票员',
            },
            {
                label: '业务范围',
                key: 'businessScope',
                type: 'select',
                required: true,
                rules: [required],
                show:true,
                disabled:true,
                dictKey: 'drawer_business_scope',
            },
            {
                label: '电子税局登录账号',
                key: 'taxAccountName',
                required: true,
                rules: [required],
                show: true,
            },
            {
                label: '密码',
                key: 'taxPassword',
                type: 'password',
                required: true,
                rules: [required],
                show:true,
                tooltip:true,
                title:'请填写登录电子税务局的账户密码，如有修改需重新激活使用',
            },
            {
                label: '状态标识',
                key: 'status',
                type: 'switcher',
                required: true,
                show: true,
                rules: [required],
            },
            {
                label: '开票类型',
                key: 'invoiceType',
                type: 'radio',
                required: true,
                rules: [required],
                show: true,
                tooltip: true,
                title: '如由新增开票员处理独立的开票业务，请选择“新增开票”；如因为原开票员工作变动，由新增开票员进行开票工作交接，请选择“交接开票”',
            },
            {
                label: '管理范围',
                key: 'orgNameList',
                type: 'glfw',
                required: true,
                show: true,
                rules: [keepLength],
            },
            {
                label: '证件类型',
                key: 'certificateType',
                type: 'select',
                required: false,
                show: true,
                dictKey: 'certificate_type',
            },
            {
                label: '证件号码',
                key: 'certificateNumber',
                required: false,
                show: true,
            },
            {
                label: '备注',
                key: 'remark',
                type: 'remark',
                required: false,
                show: true,
            },
            {
                label: '通道类型（销项）',
                key: 'channelType',
                type: 'select',
                required: true,
                show: true,
                dictKey: 'ovat_drawer_channel_type',
                rules: [required],
            },
            {
                label: '全票通服务器地址',
                key: 'qptServerUrl',
                required: false,
                show:true,
                tooltip:true,
                title:'若通道类型为“全票通”，请填写全票通服务器地址，若不填则统一走默认服务器',
            },
            {
                label: '全票通代理URL',
                key: 'qptProxyUrl',
                required: false,
                show: true,
                tooltip: true,
                title: '若通道类型为“全票通”，请填写全票通代理URL',
            },
            {
                label: '登录方式',
                key: 'loginType',
                type: 'dlfs',
                required: false,
                show:false,
                dictKey: 'qpt_login_type',
                tooltip:true,
                title:'配置是否进行自动登录以及自动登录方式：\n' +
                    '1. app短信自动登录需安装手机app注册登录，并保证app处于运行状态；\n' +
                    '\n' +
                    '2. 机构若在无需短信验证码登录的地区（广东省、天津市、湖北省、浙江省）可选择无验证码自动登录；\n' +
                    '\n' +
                    '3. 若选择手动登录，需到实名认证中进行登录后才能进行开票等操作。',
            },
            {
                label: '是否自动登录默认账号',
                key: 'isDefault',
                type: 'mrzh',
                required: false,
                show:false,
                dictKey: 'yes_no_flag',
            },
            {
                label: '邮箱账号',
                key: 'emailAccount',
                required: true,
                show: true,
                rules: [required],
                dictKey: '',
                tooltip: true,
                title: '请填写电子税局备案的手机号',
            },
        ]
        let editLabel = [
            {
                label: '姓名',
                key: 'realName',
                required: true,
                show: true,
                rules: [required],
                tooltip: true,
                title: '请填写电子税局备案的实名姓名',
            },
            {
                label: '手机号',
                key: 'mobile',
                required: true,
                rules: [required],
                show: true,
                dictKey: '',
                tooltip: true,
                title: '请填写电子税局备案的手机号',
            },
            {
                label: '身份类型',
                key: 'identityType',
                type: 'select',
                required: true,
                rules: [required],
                show: true,
                disabled: true,
                dictKey: 'identity_type',
                tooltip: true,
                title: '请确保电子税局登录账号的身份类型为开票员',
            },
            {
                label: '业务范围',
                key: 'businessScope',
                type: 'select',
                required: true,
                rules: [required],
                show:true,
                disabled:true,
                dictKey: 'drawer_business_scope',
            },
            {
                label: '电子税局登录账号',
                key: 'taxAccountName',
                required: true,
                rules: [required],
                show: true,
            },
            {
                label: '密码',
                key: 'taxPassword',
                type: 'password',
                required: true,
                rules: [required],
                show:true,
                tooltip:true,
                title:'请填写登录电子税务局的账户密码，如有修改需重新激活使用',
            },
            {
                label: '状态标识',
                key: 'status',
                type: 'switcher',
                required: true,
                show: true,
                rules: [required],
            },
            {
                label: '证件类型',
                key: 'certificateType',
                type: 'select',
                required: false,
                show: true,
                dictKey: 'certificate_type',
            },
            {
                label: '证件号码',
                key: 'certificateNumber',
                required: false,
                show: true,
            },
            {
                label: '备注',
                key: 'remark',
                type: 'remark',
                show: true,
                required: false,
            },
            {
                label: '应用范围',
                key: 'orgIdList',
                type: 'yyfw',
                required: $stateParams.isOriginalDrawer == '1' ? true : false,
                rules: $stateParams.isOriginalDrawer == '1' ? [keepLength] : '',
                show: $stateParams.isOriginalDrawer == '1' ? true : false,
                tooltip: true,
                title: '主创建机构与所属机构一致时，可选择将当前修改应用到当前机构及下级机构，保存修改后所选机构将全部做同步修改',
            },
            {
                label: '通道类型（销项）',
                key: 'channelType',
                type: 'select',
                required: true,
                show: true,
                dictKey: 'ovat_drawer_channel_type',
                rules: [required],
            },
            {
                label: '全票通服务器地址',
                key: 'qptServerUrl',
                required: false,
                show:true,
                tooltip:true,
                title:'若通道类型为“全票通”，请填写全票通服务器地址，若不填则统一走默认服务器',
            },
            {
                label: '全票通代理URL',
                key: 'qptProxyUrl',
                required: false,
                show: true,
                tooltip: true,
                title: '若通道类型为“全票通”，请填写全票通代理URL',
            },
            {
                label: '登录方式',
                key: 'loginType',
                type: 'dlfs',
                required: false,
                show:false,
                dictKey: 'qpt_login_type',
                tooltip:true,
                title:'配置是否进行自动登录以及自动登录方式：\n' +
                    '1. app短信自动登录需安装手机app注册登录，并保证app处于运行状态；\n' +
                    '\n' +
                    '2. 机构若在无需短信验证码登录的地区（广东省、天津市、湖北省、浙江省）可选择无验证码自动登录；\n' +
                    '\n' +
                    '3. 若选择手动登录，需到实名认证中进行登录后才能进行开票等操作。',
            },
            {
                label: '是否自动登录默认账号',
                key: 'isDefault',
                type: 'mrzh',
                required: false,
                show:false,
                dictKey: 'yes_no_flag',
            },
            {
                label: '邮箱账号',
                key: 'emailAccount',
                required: true,
                show: true,
                rules: [required],
                dictKey: '',
                tooltip: true,
                title: '请填写电子税局备案的手机号',
            },
        ]
        $scope.labelObjs = addLabel
        if ($scope.title == '编辑') {
            $scope.labelObjs = editLabel
        }
        $scope.dateChange = function (key) {
            switch (key) {
                case 'bgsj':
                    break

                default:
                    break
            }
        }
        $scope.selectChange = function (key) {
            switch (key) {
                case 'channelType':
                    if ($scope.title == '编辑') {
                        if($scope.formObj.channelType=== '8'){
                            $scope.labelObjs[14].show = true
                            $scope.formObj.loginType = '0'
                        }else {
                            $scope.labelObjs[14].show = false
                            $scope.formObj.loginType = ''
                            $scope.labelObjs[15].show = false
                            $scope.formObj.isDefault = ''
                        }
                    }else {
                        if($scope.formObj.channelType=== '8'){
                            $scope.labelObjs[15].show = true
                            $scope.formObj.loginType = '0'
                        }else {
                            $scope.labelObjs[15].show = false
                            $scope.formObj.loginType = ''
                            $scope.labelObjs[16].show = false
                            $scope.formObj.isDefault = ''
                        }
                    }
                    break
                case 'loginType':
                    if ($scope.title == '编辑') {
                        if($scope.formObj.loginType!== '0'){
                            $scope.labelObjs[15].show = true
                            $scope.formObj.isDefault = $scope.formObj.isDefault?$scope.formObj.isDefault:'0'
                        }else {
                            $scope.labelObjs[15].show = false
                            $scope.formObj.isDefault = ''
                        }
                    }else {
                        if($scope.formObj.loginType!== '0'){
                            $scope.labelObjs[16].show = true
                            $scope.formObj.isDefault = $scope.formObj.isDefault?$scope.formObj.isDefault:'0'
                        }else {
                            $scope.labelObjs[16].show = false
                            $scope.formObj.isDefault = ''
                        }
                    }
                    break
                case 'bglx':
                        break
                default:
                    break
            }
        }

        $scope.inputBlur = function (key) {
            switch (key) {
                case 'adjustAmt':
                    break

                default:
                    break
            }
        }

        function checkData() {
            let flag = true
            for (let i = 0; i < $scope.labelObjs.length; i++) {
                let labelObj = $scope.labelObjs[i]
                if (labelObj.rules && labelObj.rules.length) {
                    for (let index = 0; index < labelObj.rules.length; index++) {
                        const rule = labelObj.rules[index]
                        if (rule.condition($scope.formObj[labelObj.key])) {
                            labelObj.hasError = true
                            labelObj.errMsg = rule.erromsg
                            flag = false
                            break
                        }
                    }
                }
            }
            return flag
        }
        $scope.goListPage = function goListPage() {
            $state.go('outputManage.fullElectricInvoice.drawer.list')
        }
        $scope.ok = function () {
            if (!checkData()) return
            // 1、通道类型为开放平台，登录方式为空；是否自动登录默认账号为空；3、登录方式为手动登录，是否自动登录默认账号为空
            if($scope.formObj.channelType === '6'){
                $scope.formObj.loginType = ''
                $scope.formObj.isDefault = ''
            }
            if($scope.formObj.loginType === '0'){
                $scope.formObj.isDefault = ''
            }
            //新增界面若有配置服务器地址，弹出弹窗提示
            //修改界面若有修改服务器地址，弹出弹窗提示
            if($scope.title == '编辑'){
                console.log($scope.formObj)
                if($scope.formObj.initialQptServerUrl !== $scope.formObj.qptServerUrl){
                    sweetalert.confirm('提醒', '同一开票员，需配置同一个服务器，将同步修改其它机构下相同开票员的服务器地址，确定修改？').then(() => {
                        realSave()
                    })
                }else {
                    realSave()
                }
            }else {
                if($scope.formObj.qptServerUrl){
                    sweetalert.confirm('提醒', '同一开票员，需配置同一个服务器，将同步修改其它机构下相同开票员的服务器地址，确定修改？').then(() => {
                        realSave()
                    })
                }else {
                    realSave()
                }
            }
        }
        function realSave() {
            utils.loading('请求发送中...')
            httpRequest[saveApi]($scope.formObj).then((res) => {
                if (res.data.msgCode === 99999) {
                    sweetalert.confirm('提醒', '您所选择的应用范围内有部分机构下的开票员信息与当前机构开票员信息不一致，请确认是否继续将您所修改的内容同步应用到所有已勾选的机构？').then(() => {
                        $scope.formObj.editFlag = true
                        httpRequest.post_ovatTax4Drawerupdate($scope.formObj).then(() => {
                            logger.logSuccess(saveMsg)
                            $scope.goListPage()
                        })
                    })
                } else {
                    logger.logSuccess(saveMsg)
                    $scope.goListPage()
                }
            })
        }
        $scope.cancel = function () {
            $state.go('outputManage.fullElectricInvoice.drawer.list')
        }
        setTimeout(() => {
            window.jQuery('[data-toggle="tooltip"]').tooltip({ placement: 'right' })
        }, 200)

        $scope.openManageModel = function (formObj) {
            $uibModal
                .open({
                    templateUrl: 'manageModel.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'httpRequest',
                        'items1',
                        ($scope, $uibModalInstance, httpRequest, items1) => {
                            // 新增开票 - 新增管理范围 - 数结构
                            var setting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'name',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var treeObj = $.fn.zTree.getZTreeObj('orgTree')
                                        $scope.listData = treeObj.getNodes() // 树结构展示list
                                    },
                                },
                            }
                            // 交接开票 - 按组织机构查询 - 数结构
                            var orgSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'name',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var treeObj = $.fn.zTree.getZTreeObj('orgChangeTree')
                                        $scope.orgListData = treeObj.getNodes() // 树结构展示list
                                        var nodes = treeObj.getCheckedNodes() // 选中的结果值
                                        let repeatData = []
                                        angular.forEach(nodes, (item, index) => {
                                            if (item.drawerDisabledList) {
                                                item.drawerDisabledList.forEach((i, index) => {
                                                    repeatData.push(i)
                                                })
                                            }
                                        })
                                        // 结果值去重 and 格式化展示
                                        duplicateRemoval(repeatData, 1)
                                    },
                                },
                            }
                            // 交接开票 - 按开票员查询 - 数结构
                            var userSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'orgId', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'parentOrgId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'showName',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var treeObj = $.fn.zTree.getZTreeObj('userTree')
                                        $scope.userListData = treeObj.getNodes() // 树结构展示list
                                        var userListData = treeObj.getCheckedNodes()
                                        let drawerIds = []
                                        angular.forEach(userListData, (item, index) => {
                                            drawerIds.push(item.drawerId)
                                        })
                                        let data = {
                                            drawerIds: drawerIds,
                                        }
                                        // 按开票员查询 - 查询开票员管理范围
                                        httpRequest.post_getDrawersManagementScope(data).then((res) => {
                                            // 结果值去重 and 格式化展示
                                            duplicateRemoval(res.data.value, 2)
                                        })
                                    },
                                },
                            }
                            // 交接开票 - 结果值展示 - 数结构
                            var resultSetting = {
                                check: {
                                    //如果没有设置配置项，取默认配置
                                    enable: true, //显示不显示复选框
                                    chkboxType: {
                                        Y: 's',
                                        N: 'ps',
                                    },
                                },
                                data: {
                                    simpleData: {
                                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                                        idKey: 'id', //节点数据中保存唯一标识的属性名称 默认值id
                                        pIdKey: 'pid', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                                    },
                                    key: {
                                        name: 'showName',
                                    },
                                },
                                view: {
                                    showIcon: false, //是否显示节点的图标
                                    showLine: false, //是否显示节点之间的连线
                                },
                                callback: {
                                    onCheck: function (event, treeId, treeNode) {
                                        var treeObj = $.fn.zTree.getZTreeObj('resultDataTree')
                                        $scope.resultData = treeObj.getNodes() // 树结构展示list
                                    },
                                },
                            }
                            if (formObj.invoiceType == '0') {
                                $scope.modelTitle = '新增管理范围'
                                $scope.isAdd = true
                            }
                            if (formObj.invoiceType == '1') {
                                $scope.modelTitle = '交接管理范围'
                                $scope.isAdd = false
                            }
                            async function init() {
                                if (formObj.invoiceType == '0') {
                                    $scope.beforeType = items1.beforeType || '0'
                                    // 新增管理范围
                                    await httpRequest.post_getManageOrgTree().then((res) => {
                                        if (items1.beforeType == formObj.invoiceType) {
                                            $scope.listData = items1.listData?items1.listData:res.data.value
                                            $scope.listData.forEach((i) => {
                                                if (i.oldname) i.name = i.oldname
                                            })
                                        } else {
                                            $scope.listData = res.data.value
                                        }
                                    })
                                    $scope.resultData = []
                                }
                                if (formObj.invoiceType == '1') {
                                    $scope.beforeType = items1.beforeType || '1'
                                    // 交接管理范围 - 按组织机构查询
                                    await httpRequest.post_getUserManageOrgTree().then((res) => {
                                        if (items1.beforeType == formObj.invoiceType) {
                                            $scope.orgListData = items1.orgListData
                                            $scope.orgListData.forEach((i) => {
                                                if (i.oldname) i.name = i.oldname
                                                i.children.forEach((ii) => {
                                                    ii.isHidden = false
                                                    ii.nocheck = false
                                                    if (ii.oldname) ii.name = ii.oldname
                                                })
                                            })
                                        } else {
                                            $scope.orgListData = res.data.value
                                        }
                                    })
                                    $scope.resultData = items1.resultData
                                }
                                // 交接管理范围 - 按开票员查询
                                await httpRequest.post_ovatTax4DrawerUserOrgList().then((res) => {
                                    if (items1.beforeType == formObj.invoiceType) {
                                        $scope.userListData = items1.userListData
                                    } else {
                                        $scope.userListData = res.data.value
                                    }
                                    if ($scope.userListData) {
                                        angular.forEach($scope.userListData, (item, index) => {
                                            item.showName = item.realName + '(' + item.originalDrawerId + '/' + item.taxAccountName + ')'
                                        })
                                        var obj = {}
                                        $scope.userListData = $scope.userListData.reduce(function (item, next) {
                                            obj[next.originalDrawerId] ? '' : (obj[next.originalDrawerId] = true && item.push(next))
                                            return item
                                        }, [])
                                    }
                                })
                                $.fn.zTree.init($('#orgTree'), setting, $scope.listData)
                                $.fn.zTree.init($('#orgChangeTree'), orgSetting, $scope.orgListData)
                                $.fn.zTree.init($('#userTree'), userSetting, $scope.userListData)
                                $.fn.zTree.init($('#resultDataTree'), resultSetting, $scope.resultData)
                                fuzzySearch('orgTree', '#search_orgTree')
                                fuzzySearch('orgChangeTree', '#search_orgChangeTree')
                                fuzzySearch('userTree', '#search_userTree')
                                fuzzySearch('resultDataTree', '#search_resultDataTree')
                                setOrgCheck()
                                setOrgChangeCheck()
                                $('#py_org').bind('change', setOrgCheck)
                                $('#sy_org').bind('change', setOrgCheck)
                                $('#pn_org').bind('change', setOrgCheck)
                                $('#sn_org').bind('change', setOrgCheck)

                                $('#py_orgChange').bind('change', setOrgChangeCheck)
                                $('#sy_orgChange').bind('change', setOrgChangeCheck)
                                $('#pn_orgChange').bind('change', setOrgChangeCheck)
                                $('#sn_orgChange').bind('change', setOrgChangeCheck)
                            }
                            setTimeout(() => {
                                init()
                            }, 500)

                            function setOrgCheck() {
                                let zTree = $.fn.zTree.getZTreeObj('orgTree'),
                                    py = $('#py_org').attr('checked') ? 'p' : '',
                                    sy = $('#sy_org').attr('checked') ? 's' : '',
                                    pn = $('#pn_org').attr('checked') ? 'p' : '',
                                    sn = $('#sn_org').attr('checked') ? 's' : '',
                                    type = { Y: py + sy, N: pn + sn }
                                zTree.setting.check.chkboxType = type
                            }
                            function setOrgChangeCheck() {
                                let zTree = $.fn.zTree.getZTreeObj('orgChangeTree'),
                                    py = $('#py_orgChange').attr('checked') ? 'p' : '',
                                    sy = $('#sy_orgChange').attr('checked') ? 's' : '',
                                    pn = $('#pn_orgChange').attr('checked') ? 'p' : '',
                                    sn = $('#sn_orgChange').attr('checked') ? 's' : '',
                                    type = { Y: py + sy, N: pn + sn }
                                zTree.setting.check.chkboxType = type
                            }
                            $scope.orgCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('orgTree')
                                treeObj.checkAllNodes(type)
                                $scope.listData = treeObj.getNodes()
                            }
                            $scope.orgOpenAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('orgTree')
                                treeObj.expandAll(type)
                            }

                            $scope.orgChangeCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('orgChangeTree')
                                treeObj.checkAllNodes(type)
                                $scope.orgListData = treeObj.getNodes() // 树结构展示list
                                var nodes = treeObj.getCheckedNodes() // 选中的结果值
                                let repeatData = []
                                angular.forEach(nodes, (item, index) => {
                                    if (item.drawerDisabledList) {
                                        item.drawerDisabledList.forEach((i, index) => {
                                            repeatData.push(i)
                                        })
                                    }
                                })
                                // 结果值去重 and 格式化展示
                                duplicateRemoval(repeatData, 1)
                            }
                            $scope.orgChangeOpenAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('orgChangeTree')
                                treeObj.expandAll(type)
                            }

                            $scope.userCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('userTree')
                                treeObj.checkAllNodes(type)
                                $scope.userListData = treeObj.getNodes() // 树结构展示list
                                var userListData = treeObj.getCheckedNodes()
                                let drawerIds = []
                                angular.forEach(userListData, (item, index) => {
                                    drawerIds.push(item.drawerId)
                                })
                                let data = {
                                    drawerIds: drawerIds,
                                }
                                // 按开票员查询 - 查询开票员管理范围
                                httpRequest.post_getDrawersManagementScope(data).then((res) => {
                                    // 结果值去重 and 格式化展示
                                    duplicateRemoval(res.data.value, 2)
                                })
                            }

                            $scope.resultCheckAll = function (type) {
                                let treeObj = $.fn.zTree.getZTreeObj('resultDataTree')
                                treeObj.checkAllNodes(type)
                                $scope.resultData = treeObj.getNodes() // 树结构展示list
                            }

                            $scope.isOrgSelected = true
                            $scope.isUserSelected = false
                            $scope.searchData = function (v) {
                                switch (v) {
                                    case 1:
                                        $scope.isOrgSelected = true
                                        $scope.isUserSelected = false
                                        document.getElementById('getOrgSearch').className = 'is-selected col-sm-6'
                                        document.getElementById('getUserSearch').className = 'no-selected col-sm-6'

                                        break
                                    case 2:
                                        $scope.isOrgSelected = false
                                        $scope.isUserSelected = true
                                        document.getElementById('getOrgSearch').className = 'no-selected col-sm-6'
                                        document.getElementById('getUserSearch').className = 'is-selected col-sm-6'
                                        break
                                    default:
                                        break
                                }
                            }

                            // 新增开票 - 管理范围 数据格式化
                            function dataFormat() {
                                let orgIdList = []
                                let orgNameList = []

                                let result = []
                                function flatTree(nodes, parentId) {
                                    if (!nodes || nodes.length === 0) return []
                                    nodes.forEach((node) => {
                                        if (node.oldname) {
                                            result.push({
                                                id: node.id,
                                                parentOrgId: parentId,
                                                name: node.oldname,
                                                checked: node.checked,
                                            })
                                        } else {
                                            result.push({
                                                id: node.id,
                                                parentOrgId: parentId,
                                                name: node.name,
                                                checked: node.checked,
                                            })
                                        }
                                        return flatTree(node.children, node.id)
                                    })
                                }
                                flatTree($scope.listData, 0)
                                angular.forEach(result, (item, index) => {
                                    if (item.checked) {
                                        orgIdList.push(item.id)
                                        orgNameList.push(item.name)
                                    }
                                })
                                const data = {
                                    beforeType: $scope.beforeType,
                                    listData: $scope.listData,
                                    orgIdList: orgIdList,
                                    orgNameList: orgNameList,
                                }
                                return data
                            }
                            $scope.originalInOrgSearchList = items1.saveOriginalInOrgSearchList || []
                            $scope.originalInUserSearchList = items1.saveOriginalInUserSearchList || []
                            // 交接开票 - 管理范围结果值 -  去重后 数据格式化展示
                            function duplicateRemoval(repeatData, type) {
                                let inOrgSearchList = [] // 按组织机构查询树集合
                                let inUserSearchList = [] // 按开票员查询树集合
                                if (type === 1) {
                                    //组织机构
                                    angular.forEach(repeatData, (item, index) => {
                                        inOrgSearchList.push({
                                            drawerId: item.drawerId,
                                            originalDrawerId: item.originalDrawerId,
                                            showName: item.realName,
                                            id: randomID(),
                                            pid: randomID(),
                                            open: true,
                                            children: [],
                                        })
                                    })
                                    var obj = {}
                                    inOrgSearchList = inOrgSearchList.reduce(function (item, next) {
                                        obj[next.originalDrawerId] ? '' : (obj[next.originalDrawerId] = true && item.push(next))
                                        return item
                                    }, [])
                                    angular.forEach(inOrgSearchList, (item, index) => {
                                        angular.forEach(repeatData, (i, ind) => {
                                            if (item.originalDrawerId === i.originalDrawerId) {
                                                item.children.push({
                                                    id: randomID(),
                                                    pid: item.id,
                                                    orgId: i.orgId,
                                                    orgName: i.orgName,
                                                    showName: i.orgName + '-' + i.realName,
                                                    drawerId: i.drawerId,
                                                })
                                            }
                                        })
                                    })
                                    $scope.originalInOrgSearchList = inOrgSearchList
                                } else {
                                    //开票员
                                    angular.forEach(repeatData, (item, index) => {
                                        if (item.childDrawerOrgVo.length > 0) {
                                            inUserSearchList.push({
                                                drawerId: item.drawerId,
                                                showName: item.realName,
                                                originalDrawerId: item.originalDrawerId,
                                                id: randomID(),
                                                pid: randomID(),
                                                open: true,
                                                children: item.childDrawerOrgVo,
                                            })
                                        }
                                    })
                                    angular.forEach(inUserSearchList, (item, index) => {
                                        item.children.forEach((i, ind) => {
                                            i.id = randomID()
                                            i.pid = item.id
                                            i.showName = i.orgName + '-' + i.realName
                                        })
                                    })
                                    $scope.originalInUserSearchList = inUserSearchList
                                }
                                // 管理范围结果值 存在已选择数据 需先对比去重后，再判断是否需要插入新数据
                                if ($scope.originalInOrgSearchList.length > 0 && $scope.originalInUserSearchList.length > 0) {
                                    let newUserList = [...$scope.originalInOrgSearchList, ...$scope.originalInUserSearchList]
                                    var obj = {}
                                    newUserList = newUserList.reduce(function (item, next) {
                                        obj[next.drawerId] ? '' : (obj[next.drawerId] = true && item.push(next))
                                        return item
                                    }, [])
                                    resultDataFormat(newUserList)
                                } else {
                                    if ($scope.originalInOrgSearchList.length > 0) {
                                        resultDataFormat($scope.originalInOrgSearchList)
                                    } else {
                                        resultDataFormat($scope.originalInUserSearchList)
                                    }
                                }
                            }
                            //随机ID
                            function randomID() {
                                return Math.floor(Math.random() * 10000)
                            }
                            // 交接开票 - 管理范围结果值 -  数据格式化
                            function resultDataFormat(resultData) {
                                $scope.resultData = resultData
                                $.fn.zTree.init($('#resultDataTree'), resultSetting, resultData)
                                fuzzySearch('resultDataTree', '#search_resultDataTree')
                            }
                            function resultDataSubmitFormat() {
                                let orgIdList = []
                                let orgNameList = []
                                let originalDrawerIds = []
                                angular.forEach($scope.resultData, (item, index) => {
                                    if (item.children) {
                                        item.children.forEach((ele) => {
                                            if (ele.checked) {
                                                orgIdList.push(ele.orgId)
                                                orgNameList.push(ele.orgName)
                                                originalDrawerIds.push(ele.drawerId)
                                            }
                                        })
                                    }
                                })
                                const data = {
                                    beforeType: $scope.beforeType,
                                    userListData: $scope.userListData,
                                    orgListData: $scope.orgListData,
                                    resultData: $scope.resultData,
                                    saveOriginalInOrgSearchList: $scope.originalInOrgSearchList,
                                    saveOriginalInUserSearchList: $scope.originalInUserSearchList,
                                    orgIdList: orgIdList,
                                    originalDrawerIds: originalDrawerIds,
                                    orgNameList: orgNameList,
                                }
                                return data
                            }

                            $scope.ok = function ok() {
                                let data
                                if (formObj.invoiceType == '0') {
                                    data = dataFormat()
                                } else {
                                    data = resultDataSubmitFormat()
                                }
                                $uibModalInstance.close(data)
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                        },
                    ],
                    resolve: {
                        items1() {
                            return $scope.formObj
                        },
                    },
                    openedClass: 'mod-modal mod-modal-hg-g',
                    backdrop: 'static',
                })
                .result.then((result) => {
                    if (result) {
                        $scope.formObj.beforeType = result.beforeType
                        $scope.formObj.orgIdList = result.orgIdList
                        $scope.formObj.originalDrawerIds = result.originalDrawerIds
                        $scope.formObj.orgNameList = result.orgNameList

                        $scope.formObj.listData = result.listData // 用于缓存 数据展示
                        $scope.formObj.userListData = result.userListData // 用于缓存 数据展示
                        $scope.formObj.orgListData = result.orgListData // 用于缓存 数据展示
                        $scope.formObj.resultData = result.resultData // 用于缓存 数据展示
                        $scope.formObj.saveOriginalInOrgSearchList = result.saveOriginalInOrgSearchList // 用于缓存 数据展示
                        $scope.formObj.saveOriginalInUserSearchList = result.saveOriginalInUserSearchList // 用于缓存 数据展示
                    }
                })
        }
    }
}

drawerinfo.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$location', '$state', '$stateParams', '$uibModal']
export default drawerinfo



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/drawer/info.js